import { FC } from 'react';
import { UseFormRegister, FieldError } from 'react-hook-form';
import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  SimpleGrid,
} from '@chakra-ui/react';

import { CustomerFormFields } from 'page/CustomerPage/types/customerFormField';
import { SystemUpdateGroupFormBase } from '../../FormBases';

type Props = {
  register: UseFormRegister<CustomerFormFields>;
  error: FieldError | undefined;
};

/**
 * 編集モーダル用のシステム管理上のグループのフォームです。
 */
export const SystemUpdateGroupForm: FC<Props> = ({ register, error }) => (
  <FormControl isRequired isInvalid={Boolean(error)}>
    <SimpleGrid templateColumns="1fr 2fr">
      <FormLabel>システム管理上のグループ</FormLabel>
      <SystemUpdateGroupFormBase register={register} />
      <FormErrorMessage>{error && error.message}</FormErrorMessage>
    </SimpleGrid>
  </FormControl>
);
